import * as React from 'react';
import * as S from './styles';

const EmptyOperationHours: React.FC = (props) => {
  return (
    <S.Message>
      Add operation hours here by hovering on this section and clicking on the 'Edit' button.
    </S.Message>
  )
}

export default EmptyOperationHours